function Footer() {
  return (
    <div id="footer">
      <ul>
        <li>
          <a href="https://unlicense.org/">The Unlicensed</a>
        </li>
        <li>&copy;</li>
        <li>
          <a href="https://charliegp.vercel.app/">charliegp 2022</a>
        </li>
        <li>&bull;</li>
        <li>
          Hosted by&nbsp;
          <a
            className="border-bottom border-1 border-dark"
            href="https://www.vercel.com"
          >
            Vercel
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Footer;
